import { jsx as u, Fragment as I } from "react/jsx-runtime";
import { noop as p } from "lodash/fp";
import S from "react";
import { onItemClick as g } from "./index.es2482.js";
import { useEventRefresher as h, useReadableEventRefresher as M } from "@zdrbm/zdr-react";
import { MultiSelectDropdownMenuContextProvider as C } from "./index.es2487.js";
import { useDropDownMenu as v } from "./index.es2488.js";
import { useMultiselectState as k } from "./index.es2489.js";
import { MultiSelectItem as D } from "./index.es84.js";
import { MenuListContainer as w } from "./index.es88.js";
import { BASIC_MENU_ITEM_HEIGHT as x } from "./index.es83.js";
const E = (o) => {
  const { index: r, style: l } = o, e = k();
  h(e.highlightedItems, e.autoFocus);
  const [[i]] = M(e.autoFocus), t = e.getItemByIndex(r), m = e.getItemsLength();
  return t ? /* @__PURE__ */ u(
    D,
    {
      onItemSelect: () => {
        e.invokeItemSelected(t);
      },
      autoFocus: i && r === 0,
      isSelected: !!t.isSelected,
      ...t,
      hasDivider: r < m - 1,
      wrapperStyle: l
    },
    t.value
  ) : /* @__PURE__ */ u(I, {});
}, G = ({
  items: o,
  maxVisibleItems: r,
  onSelection: l,
  onItemSelection: e = p,
  onItemsFiltered: i = p,
  searchTerm: t,
  NoResultsItem: m,
  autoFocus: a = !1,
  state: f
}) => {
  const d = S.useCallback(
    ({ item: n }) => {
      var c;
      g(o, n.value, "multiple", e, l), (c = n.onClick) == null || c.call(n, {});
    },
    [o, e, l]
  ), s = v({
    state: f,
    searchTerm: t,
    autoFocus: a,
    items: o,
    onItemClick: d,
    onItemsFiltered: i
  });
  return /* @__PURE__ */ u(C, { multiSelectDropdownMenuState: s, children: /* @__PURE__ */ u(
    w,
    {
      itemHeight: x,
      itemCount: t ? s.getItemsLength() : o.length,
      maxVisibleItems: r,
      NoResults: m,
      role: "group",
      children: E
    }
  ) });
};
export {
  G as MultiSelectDropdownMenu,
  E as MultiSelectWrapperItem
};
//# sourceMappingURL=index.es77.js.map
